import client from "../../client/client";

class AiWorkflowService {
	exportWorkflows(cancelToken) {
		return client.post("/ai/workflows/export/all", {
			config: { cancelToken },
		});
	}

	importWorkFlows(payload, cancelToken) {
		return client.post("/ai/workflows/import", {
			payload,
			config: { cancelToken },
		});
	}

	downloadTrace({ executionId }, cancelToken) {
		return client.download(`/ai/workflows/execution/${executionId}/download-trace`, {
			config: { cancelToken },
		});
	}

	getDefinitionList(
		{ definitionId, userId, titleContains, descriptionContains, createdAfter, pattern, page, size, sort },
		cancelToken
	) {
		return client.get("/ai/workflows/list-definition", {
			params: {
				definitionId,
				userId,
				titleContains,
				descriptionContains,
				createdAfter,
				pattern,
				page,
				size,
				sort,
			},
			config: { cancelToken },
		});
	}

	getExecutionList({ agentName = "", page = 0, size = 25, sort = "" }, cancelToken) {
		return client.get("/ai/workflows/list-execution", {
			params: { agentName, page, size, sort },
			config: { cancelToken },
		});
	}

	forceCriteriaState({ projectId, executionId }, cancelToken) {
		return client.patch(`/ai/workflows/force-criteria-state/${projectId}`, {
			params: { executionId },
			config: { cancelToken },
		});
	}
}
export default new AiWorkflowService();
